import { render, staticRenderFns } from "./OrganisationsSummary.vue?vue&type=template&id=7310b9c1&scoped=true"
import script from "./OrganisationsSummary.vue?vue&type=script&lang=js"
export * from "./OrganisationsSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7310b9c1",
  null
  
)

export default component.exports